import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ResultComponent } from '../../../ui/api/result.component';
import { StoreCreditToggleComponentDef } from '../store-credit-toggle.component.def';

@Component({
    selector: 'store-credit-apply',
    templateUrl: './store-credit-apply.component.html',
    standalone: true,
    imports: [CommonModule, PriceComponent, ResultComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreCreditApplyComponent extends StoreCreditToggleComponentDef {}
